module.exports = __webpack_public_path__ + "static/img/indexBg.d61aaec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexBg.png
// module id = L9L/
// module chunks = 18